(() => {
  if (customElements.get('nl6-purchase-facts')) return;
  const aliases = {
    dimensions: ['mitat','mått','dimensions','korkeus','höjd','height','leveys','bredd','width','pituus','längd','length','syvyys','djup','depth','halkaisija','diameter','läpimitta','skärmens diameter','varjostimen halkaisija','skärmhöjd','varjostimen korkeus'],
    source: ['valonlähde','ljuskälla','light source','lampunkanta','lamppukanta','kanta','sockel','socket','bulb base','integroitu led','integrerad led','lampunkanta / valonlähde','sockel / ljuskälla'],
    temperature: ['värilämpötila','färgtemperatur','color temperature','colour temperature'],
    dimmable: ['himmennettävyys','himmennettävä','dimbarhet','dimbar','dimmable','dimming'],
    ip: ['ip-luokitus','ip luokitus','ip-klass','ip class','ip rating','kotelointiluokka','kapslingsklass'],
    lumens: ['valovirta','ljusflöde','luminous flux','lumens'],
    included: ['valonlähde mukana','valonlähde toimituksessa','lamppu mukana','polttimo mukana','valonlähde sisältyy','lamppu sisältyy','sisältää lampun','ljuskälla ingår','bulb included','medföljande ljuskälla']
  };
  const normalize = value => (value || '').replace(/\s+/g,' ').trim();
  const labelKey = value => normalize(value).replace(/[:.：]+$/,'').trim().toLocaleLowerCase();
  const identity = root => normalize(root.textContent).match(/(?:Tuotenumero|Artikelnummer|SKU)\s*:?\s*([A-Za-z0-9][A-Za-z0-9._/-]*)/i)?.[1];
  const rowData = (label, value, specific = false) => {
    label = normalize(label).replace(/[:.：]+$/,''); value = normalize(value);
    const unit = label.match(/\((cm|mm|m|lm|k)\)$/i)?.[1];
    const key = labelKey(label.replace(/\s*\((?:cm|mm|m|lm|k)\)$/i,'').replace(/^(mitat|mått|dimensions)\s*\(.+\)$/i,'$1'));
    const field = Object.keys(aliases).find(name => aliases[name].includes(key));
    if (!field || !value || /^[-–—?]+$/.test(value) || value.length > 180) return null;
    if (unit && /^[\d.,\s/×x-]+$/.test(value)) value += ' ' + unit;
    return {field,key,label:label.replace(/\s*\((?:cm|mm|m|lm|k)\)$/i,''),value,specific};
  };
  const read = root => [...root.querySelectorAll('li,tr,dl > div,p > strong')].flatMap(row => {
    let label, value;
    if (row.matches('p > strong')) {
      label = row.textContent; value = ''; let next = row.nextSibling;
      while (next && !(next.nodeType === 1 && /^(BR|STRONG)$/.test(next.tagName))) { value += next.textContent; next = next.nextSibling; }
    } else if (row.matches('dl > div')) {
      const dt = row.querySelector(':scope > dt'), dd = row.querySelector(':scope > dd');
      if (!dt || !dd) return [];
      label = dt.textContent; value = dd.textContent;
    } else if (row.matches('tr')) {
      if (row.children.length !== 2 || row.querySelector('th')) return [];
      label = row.children[0].textContent; value = row.children[1].textContent;
    } else {
      if (row.querySelector('li,tr,dl')) return [];
      if (row.firstElementChild?.tagName === 'STRONG') {
        label = row.firstElementChild.textContent;
        const copy = row.cloneNode(true); copy.firstElementChild.remove(); value = copy.textContent;
      } else {
        const parts = row.textContent.split(':'); if (parts.length < 2) return [];
        label = parts.shift(); value = parts.join(':');
      }
    }
    const data = rowData(label,value);
    return data ? [data] : [];
  });
  const project = (source, sku, variantCount) => {
    const doc = source.cloneNode(true), specific = [], issues = [];
    doc.querySelectorAll('[role="listitem"]').forEach(card => {
      const cardSku = identity(card);
      if (!cardSku) return;
      if (cardSku === sku) specific.push(...read(card));
      card.remove();
    });
    doc.querySelectorAll('table').forEach(table => {
      const tableRows = [...table.querySelectorAll('tr')];
      const header = tableRows.find(row => /^(sku|tuotenumero|artikelnummer)$/i.test(normalize(row.cells[0]?.textContent)));
      if (!header) {
        if (tableRows.some(row => row.children.length > 2)) { issues.push('unmapped_table'); table.remove(); }
        return;
      }
      const selected = tableRows.find(row => normalize(row.cells[0]?.textContent) === sku);
      if (selected) [...header.cells].slice(1).forEach((cell,index) => {
        const data = rowData(cell.textContent,selected.cells[index+1]?.textContent,true);
        if (data) specific.push(data);
      });
      else issues.push('missing_variant_table_row');
      table.remove();
    });
    const headings = [...doc.querySelectorAll('h3,h4,h5,h6')].map(heading => {
      const nodes = []; let next = heading.nextElementSibling;
      while (next && !/^H[1-6]$/.test(next.tagName)) { nodes.push(next); next = next.nextElementSibling; }
      const fragment = document.createElement('div'); nodes.forEach(node => fragment.append(node.cloneNode(true)));
      const headingSku = normalize(heading.textContent).match(/^([A-Za-z0-9][A-Za-z0-9._/-]*)\s*[–—]\s+/)?.[1];
      return {heading,nodes,fragment,sku:identity(fragment) || headingSku};
    }).filter(group => group.sku);
    const uniqueSkus = new Set(headings.map(group => group.sku));
    if (uniqueSkus.size > 1) {
      let matched = false;
      headings.forEach(group => {
        if (group.sku === sku) { specific.push(...read(group.fragment)); matched = true; }
        group.nodes.forEach(node => node.remove()); group.heading.remove();
      });
      if (!matched && variantCount > 1) issues.push('unmatched_variant_section');
    }
    const keys = new Set(specific.map(row => row.key));
    return {rows:[...read(doc).filter(row => !keys.has(row.key)),...specific.map(row => ({...row,specific:true}))],issues};
  };
  class PurchaseFacts extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true') return;
      const template = this.querySelector('[data-nl6-description]');
      const list = this.querySelector('[data-nl6-facts-list]');
      if (!template || !list) return;
      const {rows,issues} = project(template.content,this.dataset.sku,Number(this.dataset.variantCount || 1));
      const seeds = {};
      list.querySelectorAll('[data-nl6-fact]').forEach(row => {
        const value = normalize(row.querySelector('dd')?.textContent);
        if (value) seeds[row.dataset.nl6Fact] = {value,specific:row.dataset.nl6Scope === 'variant'};
      });
      const localize = value => {
        const labels = {'kyllä':this.dataset.yes,'ja':this.dataset.yes,'yes':this.dataset.yes,'ei':this.dataset.no,'nej':this.dataset.no,'no':this.dataset.no,'integroitu led':this.dataset.led,'integrerad led':this.dataset.led,'himmennettävällä lampulla':this.dataset.withBulb};
        return labels[labelKey(value)] || value;
      };
      const output = [];
      for (const field of Object.keys(aliases)) {
        let entries = rows.filter(row => row.field === field);
        const seed = seeds[field];
        if (seed?.specific) entries = [{field,key:field,label:this.dataset[field],value:seed.value,specific:true}];
        else if (entries.some(row => row.specific)) entries = entries.filter(row => row.specific);
        else if (seed) entries = [{field,key:field,label:this.dataset[field],value:seed.value}];
        if (!entries.length) continue;
        if (entries.some(row => /(?:beroende på|depending on|vaihtelee|varierar|tarkista|kontrollera|verify|malliversion|modellversion)/i.test(row.value))) {
          issues.push('ambiguous_' + field); continue;
        }
        const normalized = row => labelKey(['integroitu led','integrerad led'].includes(row.key) && /^(kyllä|ja|yes)$/i.test(row.value) ? this.dataset.led : localize(row.value));
        const conflict = field === 'source'
          ? entries.some(row => entries.some(other => {
              const group = item => /^(?:lampunkanta|lamppukanta|kanta|sockel|socket|bulb base)$/.test(item.key) ? 'socket' : /^(?:integroitu led|integrerad led)$/.test(item.key) ? 'led' : 'source';
              return group(row) === group(other) && normalized(row) !== normalized(other);
            }))
          : field === 'dimensions'
          ? entries.some(row => entries.some(other => row.key === other.key && normalized(row) !== normalized(other)))
          : new Set(entries.map(normalized)).size > 1;
        if (conflict) { issues.push('conflicting_' + field); continue; }
        const uniqueEntries = entries.filter((row,index) => entries.findIndex(other => normalized(other) === normalized(row) && (field !== 'dimensions' || other.key === row.key)) === index);
        const values = [...new Set(uniqueEntries.map(row => {
          if (field === 'dimensions' && !['mitat','mått','dimensions'].includes(row.key)) {
            const term = ['halkaisija','diameter','läpimitta'].includes(row.key) ? 'Ø' : row.label;
            return term + ': ' + row.value;
          }
          if (['integroitu led','integrerad led'].includes(row.key)) return /^(kyllä|ja|yes)$/i.test(row.value) ? this.dataset.led : row.label + ': ' + row.value;
          return localize(row.value);
        }))];
        const row = document.createElement('div'); row.dataset.nl6Fact = field;
        const term = document.createElement('dt'); term.textContent = this.dataset[field];
        const value = document.createElement('dd'); value.textContent = values.join(' · ');
        row.append(term,value); output.push(row);
      }
      list.replaceChildren(...output);
      this.hidden = !output.length;
      this.dataset.loaded = 'true';
      this.dataset.nl6Issues = [...new Set(issues)].join(',');
    }
  }
  customElements.define('nl6-purchase-facts',PurchaseFacts);
})();
